import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Tag } from 'antd';
import { EntrarNaLista } from '../components/EntrarNaLista';
import { Revela } from '../components/Revela';
import { destinos } from '../destinos';

export function Modulos() {
  return (
    <section id="modulos" className="landing-secao modulos-secao">
      <Revela>
        <div className="secao-abertura">
          <span className="sobretitulo">DO ENAC À TITULARIDADE</span>
          <h2>
            Uma preparação.
            <br />
            <em>Cada etapa no seu lugar.</em>
          </h2>
          <p>
            O Enac e a 1ª fase dos concursos estaduais de cartório já estão disponíveis. A 2ª fase
            vem a seguir.
          </p>
        </div>
      </Revela>
      <div className="modulos-grade">
        <Revela>
          <article className="modulo-cartao modulo-disponivel">
            <div className="modulo-topo">
              <span className="sobretitulo">EXAME NACIONAL DOS CARTÓRIOS</span>
              <Tag color="success">Disponível</Tag>
            </div>
            <h3>
              Enac<span aria-hidden="true"> ↗</span>
            </h3>
            <p>Questões comentadas alternativa por alternativa, para construir uma base sólida.</p>
            <ul>
              <li>Comentários com fundamento</li>
              <li>Filtros por disciplina e assunto</li>
              <li>Legislação Comentada incluída</li>
            </ul>
            <Button
              type="primary"
              size="large"
              href={destinos.criarConta}
              icon={<ArrowRightOutlined />}
              iconPlacement="end"
            >
              Criar conta grátis
            </Button>
            <small>Comece com a cota semanal gratuita. Sem cartão.</small>
          </article>
        </Revela>
        <div className="modulos-proximos">
          {/*
            **No ar desde 15/10/2026**, e no mesmo lugar em que esperava: o Enac
            continua sendo a porta de entrada, porque é a prova que todo
            candidato faz antes das estaduais. O botão é o mesmo cadastro do
            Enac, só que aterrissando nas questões da 1ª fase - a landing não
            tem tabela de preços desde 22/09, e quem decide o acesso é o app.
          */}
          <Revela>
            <article className="modulo-cartao modulo-aberto">
              <div className="modulo-topo">
                <span className="sobretitulo">CONCURSOS ESTADUAIS</span>
                <Tag color="success">Disponível</Tag>
              </div>
              <h3>1ª fase</h3>
              <p>
                Questões objetivas das provas estaduais, comentadas e organizadas por banca, estado,
                disciplina e assunto.
              </p>
              <Button
                size="large"
                href={destinos.primeiraFase}
                icon={<ArrowRightOutlined />}
                iconPlacement="end"
              >
                Ver as questões
              </Button>
            </article>
          </Revela>
          <Revela>
            <article className="modulo-cartao modulo-futuro">
              <div className="modulo-topo">
                <span className="sobretitulo">CONCURSOS ESTADUAIS</span>
                <Tag>Em breve</Tag>
              </div>
              <h3>2ª fase</h3>
              <p>Dissertação, peça prática e questões discursivas, com espelho de correção.</p>
              <EntrarNaLista
                topic="modulo:essay"
                source="landing"
                convite="Receba o aviso de lançamento."
                confirmacao="Pronto. Você está na fila da 2ª fase."
              />
            </article>
          </Revela>
        </div>
      </div>
    </section>
  );
}
